import { defineComponent as _defineComponent } from 'vue';
import { BAlert, BCard, BFormGroup, BFormInput } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, ref, watch } from "vue";
import { useRouter } from "vue-router/composables";
import { getRedirectOnImportPath } from "@/components/Workflow/redirectPath";
import { Services } from "@/components/Workflow/services";
import { Toast } from "@/composables/toast";
import { useUserStore } from "@/stores/userStore";
import LoadingSpan from "@/components/LoadingSpan.vue";
import TrsServerSelection from "@/components/Workflow/Import/TrsServerSelection.vue";
import TrsTool from "@/components/Workflow/Import/TrsTool.vue";
import TrsUrlImport from "@/components/Workflow/Import/TrsUrlImport.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TrsImport',
    props: {
        isRun: { type: Boolean },
        queryTrsId: null,
        queryTrsUrl: null,
        queryTrsServer: null,
        queryTrsVersionId: null
    },
    setup(__props) {
        const props = __props;
        const trsTool = ref(null);
        const loading = ref(false);
        const importing = ref(false);
        const trsSelection = ref(null);
        const errorMessage = ref(null);
        const toolId = ref(props.queryTrsId);
        const { isAnonymous } = storeToRefs(useUserStore());
        const isAutoImport = ref(Boolean((props.queryTrsVersionId && props.queryTrsServer && props.queryTrsId) || props.queryTrsUrl));
        const toolIdTrimmed = computed(() => {
            return toolId.value?.trim() || null;
        });
        const hasErrorMessage = computed(() => {
            return errorMessage.value != null;
        });
        watch(toolIdTrimmed, () => {
            onToolId();
        });
        const services = new Services();
        async function onToolId() {
            trsTool.value = null;
            errorMessage.value = null;
            if (!trsSelection.value || !toolIdTrimmed.value) {
                return;
            }
            loading.value = true;
            try {
                const tool = await services.getTrsTool(trsSelection.value.id, toolIdTrimmed.value);
                trsTool.value = tool;
                if (isAutoImport.value) {
                    let versionField = "name";
                    const version = trsTool.value.versions.find((version) => {
                        if (version.name === props.queryTrsVersionId) {
                            return true;
                        }
                        else if (version.id === props.queryTrsVersionId) {
                            versionField = "id";
                            return true;
                        }
                    });
                    if (version) {
                        importVersion(trsSelection.value.id, trsTool.value.id, version[versionField], props.isRun);
                    }
                    else {
                        Toast.warning(`Specified version: ${props.queryTrsVersionId} doesn't exist`);
                        isAutoImport.value = false;
                    }
                }
            }
            catch (error) {
                trsTool.value = null;
                errorMessage.value = error;
            }
            finally {
                loading.value = false;
            }
        }
        function onTrsSelection(selection) {
            trsSelection.value = selection;
            if (toolIdTrimmed.value) {
                onToolId();
            }
        }
        function onTrsSelectionError(message) {
            errorMessage.value = message;
        }
        const router = useRouter();
        async function importVersion(trsId, toolIdToImport, version, isRunFormRedirect = false) {
            if (!trsId || !toolIdToImport) {
                errorMessage.value = "Import Failed. Unknown Id";
                return;
            }
            importing.value = true;
            errorMessage.value = null;
            try {
                const response = await services.importTrsTool(trsId, toolIdToImport, version);
                const path = getRedirectOnImportPath(response, isRunFormRedirect);
                router.push(path);
            }
            catch (error) {
                errorMessage.value = error || "Import failed for an unknown reason.";
            }
            finally {
                importing.value = false;
            }
        }
        async function importVersionFromUrl(url, isRunFormRedirect = false) {
            importing.value = true;
            errorMessage.value = null;
            try {
                const response = await services.importTrsToolFromUrl(url);
                const path = getRedirectOnImportPath(response, isRunFormRedirect);
                router.push(path);
            }
            catch (error) {
                errorMessage.value = error || "Import failed for an unknown reason.";
            }
            finally {
                importing.value = false;
            }
        }
        return { __sfc: true, props, trsTool, loading, importing, trsSelection, errorMessage, toolId, isAnonymous, isAutoImport, toolIdTrimmed, hasErrorMessage, services, onToolId, onTrsSelection, onTrsSelectionError, router, importVersion, importVersionFromUrl, BAlert, BCard, BFormGroup, BFormInput, LoadingSpan, TrsServerSelection, TrsTool, TrsUrlImport };
    }
});
